export enum QuoteApiRoutes {
  CancelQuote = '/quotes/:id/cancel',
  CloseQuote = '/quotes/:id/close',
  CancelQuoteValidation = '/quotes/:id/validate-cancel',
  ReopenClosedQuote = '/quotes/:id/reopen',
  DealLogEntries = '/quotes/deal-log',
  MoxyCustomerNumberSearch = '/quotes/quoteId',
  ProjectedFirstPaymentDateCalculate = '/quotes/projected-first-payment-date/calculate',
  Quote = '/quotes',
  QuoteById = '/quotes/:id',
  RewriteDiffById = '/quotes/:id/rewrite-diff',
  QuotePreviousAdditionalHoldersById = '/quotes/:id/contract-additional-holders',
  Cart = '/quotes/:id/cart',
  CalculateEquity = 'quotes/:id/calculate-equity',
  QuoteFlowAdditionalHolders = '/quotes/:id/additional-policy-holders',
  QuoteFlowContactInfo = '/quotes/:id/contact-info',
  EmailContract = '/quotes/:id/email-contract',
  MailContract = '/quotes/:id/mail-contract',
  FulfillmentLanguagePreference = '/quotes/:id/language-preference',
  QuoteFlowPaymentDetails = '/quotes/:id/payment-details',
  QuoteFlowPaymentMethod = '/quotes/:id/payment-method',
  QuoteFlowCompleteRecap = '/quotes/:id/complete-recap',
  QuoteFlowSelectPlan = '/quotes/:id/select-plan',
  QuoteFlowVehicleDetails = '/quotes/:id/vehicle-details',
  QuoteFlowVinAndMileage = '/quotes/:id/vin-and-mileage',
  QuoteFlowVehicleModifications = '/quotes/:id/usage-and-modifications',
  QuoteFlowWrapCall = '/quotes/:id/wrap-call',
  QuoteFlowEquity = '/quotes/:id/equity',
  QuoteFlowCompleteRewrite = '/quotes/:id/complete-rewrite',
  QuoteFlowConfirmRewrite = '/quotes/:id/confirm-rewrite',
  QuoteInitialWorkflowSteps = '/quotes/initial-workflow-steps',
  ProcessPayment = '/quotes/:id/process-payment',
  SalePendingDetails = '/quotes/:id/sale-pending',
  QuoteTransferToSales = '/quotes/:id/transfer-to-sales',
  UpdateSdr = '/quotes/:id/sdr',
  UpdateSoldByRep = '/quotes/:id/sold-by-rep',
  VerificationChecklist = '/quotes/:id/verification-checklist',
  ReturnToRetention = '/quotes/:id/return-to-retention',
  CreateRetention = '/quotes/:id/create-retention',
  QuoteRetention = '/quotes/:id/retention',
}
